if (!customElements.get('collection-explorer')) {
  customElements.define(
    'collection-explorer',
    class CollectionExplorer extends HTMLElement {
      constructor() {
        super();
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onBlockDeselect = this.onBlockDeselect.bind(this);
      }

      connectedCallback() {
        this.overview = this.querySelector('[data-overview]');
        this.panels = Array.from(this.querySelectorAll('.dezmas-products__panel'));

        // Cards stay real links to the collection page; with JS they open the products in place.
        this.querySelectorAll('[data-open-panel]').forEach((trigger) => {
          trigger.addEventListener('click', (event) => {
            const panel = this.querySelector(`#${trigger.dataset.openPanel}`);
            if (!panel) return;
            event.preventDefault();
            this.open(panel, trigger);
          });
        });

        this.querySelectorAll('[data-close-panel]').forEach((button) => {
          button.addEventListener('click', () => this.close());
        });

        this.panels.forEach((panel) => {
          panel.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') this.close();
          });
        });

        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      // In the theme editor, selecting a collection block opens its products.
      onBlockSelect(event) {
        if (!this.panels.includes(event.target)) return;
        const trigger = this.querySelector(`[data-open-panel="${event.target.id}"]`);
        this.open(event.target, trigger, false);
      }

      onBlockDeselect(event) {
        if (this.panels.includes(event.target)) this.close(false);
      }

      open(panel, trigger, moveFocus = true) {
        this.activeTrigger = trigger;
        if (trigger) trigger.setAttribute('aria-expanded', 'true');

        this.overview.hidden = true;
        this.panels.forEach((p) => {
          p.hidden = p !== panel;
        });
        this.replayEntrance(panel);

        this.scrollToTop();
        // Focus the back button: it's the next action, and the panel's region label is announced with it.
        const backButton = panel.querySelector('[data-close-panel]');
        if (moveFocus && backButton) backButton.focus({ preventScroll: true });
      }

      close(moveFocus = true) {
        this.panels.forEach((p) => {
          p.hidden = true;
        });
        this.overview.hidden = false;
        this.replayEntrance(this.overview);

        const trigger = this.activeTrigger;
        this.activeTrigger = null;
        this.scrollToTop();
        if (!trigger) return;
        trigger.setAttribute('aria-expanded', 'false');
        if (moveFocus) trigger.focus({ preventScroll: true });
      }

      replayEntrance(element) {
        element.classList.remove('is-entering');
        void element.offsetWidth;
        element.classList.add('is-entering');
      }

      // Bring the top of the explorer into view when the swap leaves the visitor scrolled past it.
      scrollToTop() {
        const header = document.querySelector('.section-header');
        const offset = (header ? header.offsetHeight : 0) + 24;
        const top = this.getBoundingClientRect().top;
        if (top >= offset) return;

        window.scrollTo({
          top: window.scrollY + top - offset,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      }
    }
  );
}
